class ChiefComplaintAdvices {
  constructor(note, priority, chiefComplaintId) {
    this.note = note;
    this.priority = priority;
    this.chiefComplaintId = chiefComplaintId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allChiefComplaintAdvices: [],
      chiefComplaintAdvice: new ChiefComplaintAdvices('', null, null),
      allClinicalTriagessForOther: [],
    };
  },
  methods: {
    getAllAdviceGuidance: function (chiefComplaintId) {
      this.load.val = true;
      this.$store
        .dispatch('getAllClinicalTriages', chiefComplaintId)
        .then(() => {
          if (this.$store.state.clinicalTriageModule.successFlag) {
            const data =
              this.$store.state.clinicalTriageModule.allClinicalTriages;
            this.allChiefComplaintAdvices = this.transformAdvicesList(data);
          } else {
            if (this.$store.state.clinicalTriageModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllAdviceGuidance(chiefComplaintId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.clinicalTriageModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllAdviceGuidance(chiefComplaintId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    getAdviceGuidanceAdvice: function (chiefComplaintTechnicianAdviceId) {
      this.load.val = true;
      this.$store
        .dispatch('getClinicalTriage', chiefComplaintTechnicianAdviceId)
        .then(() => {
          if (this.$store.state.clinicalTriageModule.successFlag) {
            const data =
              this.$store.state.clinicalTriageModule.clinicalTriage;
            this.setAdviceGuidance(data);
          } else {
            if (this.$store.state.clinicalTriageModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAdviceGuidanceAdvice(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.clinicalTriageModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAdviceGuidanceAdvice(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    setAdviceGuidance: function (data) {
      this.chiefComplaintAdvice.id = data.id;
      this.chiefComplaintAdvice.note = data.note;
      this.chiefComplaintAdvice.priority = data.priority;
      this.chiefComplaintAdvice.chiefComplaintId = this.chiefComplaintId;
    },
    addAdviceGuidance: function () {
      if (this.onValidate()) {
        const body = this.setAddBody();
        this.load.val = true;
        this.$store
          .dispatch('addClinicalTriage', body)
          .then(() => {
            if (this.$store.state.clinicalTriageModule.successFlag) {
              this.$refs.confirm.showConfirmDialog = false;
              this.showAddEditModal = false;
              this.disabelConfirm = false;
              this.showSuccessAlert('توصیه/راهنما با موفقیت اضافه شد');
              this.resetAdviceGuidanceBody();
              this.getAllAdviceGuidance(this.chiefComplaintId);
            } else {
              this.disabelConfirm = false;
              if (this.$store.state.clinicalTriageModule.errorStatus) {
                this.$store.dispatch('refreshToken').then(() => {
                  if (this.$store.state.userModule.successFlag) {
                    this.addAdviceGuidance();
                  } else {
                    this.$router.push({ name: 'login' });
                  }
                });
              } else if (this.$store.state.clinicalTriageModule.error400) {
                this.$store.dispatch('csrf').then(() => {
                  if (this.$store.state.loginModule.successFlag) {
                    this.addAdviceGuidance();
                  } else {
                    this.$router.push({ name: 'login' });
                  }
                });
              } else {
                this.showError();
              }
            }
          })
          .finally(() => {
            this.load.val = false;
          });
      }
    },
    editAdviceGuidance: function () {
      if (this.onValidate()) {
        this.setEditBody();
        this.load.val = true;
        this.$store
          .dispatch('editClinicalTriage', this.chiefComplaintAdvice)
          .then(() => {
            if (this.$store.state.clinicalTriageModule.successFlag) {
              this.getAllAdviceGuidance(this.chiefComplaintId);
              this.showSuccessAlert('توصیه/راهنما با موفقیت ویرایش شد.');
              this.$refs.confirm.showConfirmDialog = false;
              this.disabelConfirm = false;
              this.showAddEditModal = false;
              this.resetAdviceGuidanceBody();
            } else {
              this.disabelConfirm = false;
              if (this.load.val) {
                this.load.val = false;
              }
              if (this.$store.state.clinicalTriageModule.errorStatus) {
                this.$store.dispatch('refreshToken').then(() => {
                  if (this.$store.state.userModule.successFlag) {
                    this.editClinicalTriagesFunction();
                  } else {
                    this.$router.push({ name: 'login' });
                  }
                });
              } else if (this.$store.state.clinicalTriageModule.error400) {
                this.$store.dispatch('csrf').then(() => {
                  if (this.$store.state.loginModule.successFlag) {
                    this.editClinicalTriagesFunction();
                  } else {
                    this.$router.push({ name: 'login' });
                  }
                });
              } else {
                this.showError();
              }
            }
          });
      }
    },
    deleteAdviceGuidance: function (chiefComplaintTechnicianAdviceId) {
      this.load.val = true;
      this.$store
        .dispatch('deleteClinicalTriage', chiefComplaintTechnicianAdviceId)
        .then(() => {
          if (this.$store.state.clinicalTriageModule.successFlag) {
            this.disabelConfirm = false;
            this.$refs.confirm.showConfirmDialog = false;
            this.getAllAdviceGuidance(this.chiefComplaintId);
            this.showSuccessAlert('توصیه/راهنما با موفقیت حذف شد');
          } else {
            this.disabelConfirm = false;
            if (this.$store.state.clinicalTriageModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.deleteAdviceGuidance(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.clinicalTriageModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.deleteAdviceGuidance(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    activateAdviceGuidance: function (chiefComplaintTechnicianAdviceId) {
      this.load.val = true;
      this.$store
        .dispatch('activateClinicalTriage', chiefComplaintTechnicianAdviceId)
        .then(() => {
          if (this.$store.state.clinicalTriageModule.successFlag) {
            this.disabelConfirm = false;
            this.$refs.confirm.showConfirmDialog = false;
            this.getAllAdviceGuidance(this.chiefComplaintId);
            this.showSuccessAlert('توصیه/راهنما با موفقیت فعال شد');
          } else {
            this.disabelConfirm = false;
            if (this.$store.state.clinicalTriageModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.activateAdviceGuidance(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.clinicalTriageModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.activateAdviceGuidance(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    deactivateAdviceGuidance: function (chiefComplaintTechnicianAdviceId) {
      this.load.val = true;
      this.$store
        .dispatch('deactivateClinicalTriage', chiefComplaintTechnicianAdviceId)
        .then(() => {
          if (this.$store.state.clinicalTriageModule.successFlag) {
            this.disabelConfirm = false;
            this.$refs.confirm.showConfirmDialog = false;
            this.getAllAdviceGuidance(this.chiefComplaintId);
            this.showSuccessAlert('توصیه/راهنما با موفقیت غیرفعال شد');
          } else {
            this.disabelConfirm = false;
            if (this.$store.state.clinicalTriageModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.deactivateAdviceGuidance(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.clinicalTriageModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.deactivateAdviceGuidance(chiefComplaintTechnicianAdviceId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    resetAdviceGuidanceBody: function () {
      this.chiefComplaintAdvice = new ChiefComplaintAdvices('', null, null);
    },
    setAddBody: function () {
      const body = {
        chiefComplaintId: this.chiefComplaintId,
        priority: Number(this.chiefComplaintAdvice.priority),
        note: this.chiefComplaintAdvice.note,
      };
      return body;
    },
    setEditBody: function () {
      const body = {
        chiefComplaintId: this.chiefComplaintId,
        priority: Number(this.chiefComplaintAdvice.priority),
        note: this.chiefComplaintAdvice.note,
        id: this.chiefComplaintAdvice.id,
      };
      return body;
    },
    showError: function () {
      this.snackText = this.$store.state.clinicalTriageModule.error;
      this.showErrorAlert(this.snackText);
    },
  },

  computed: {
    clinicalTriagepriority() {
      return Array.from(
        { length: this.allChiefComplaintAdvices.length + 1 },
        (_, index) => index + 1,
      );
    },
  },
};
